import { render, staticRenderFns } from "./FormContinueTab.vue?vue&type=template&id=14246dfc&"
import script from "./FormContinueTab.vue?vue&type=script&lang=ts&"
export * from "./FormContinueTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14246dfc')) {
      api.createRecord('14246dfc', component.options)
    } else {
      api.reload('14246dfc', component.options)
    }
    module.hot.accept("./FormContinueTab.vue?vue&type=template&id=14246dfc&", function () {
      api.rerender('14246dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/FormContinueTab.vue"
export default component.exports